document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-nav-close]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
    });
  }
  if (mobileNav) {
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) mobileNav.classList.remove('is-open');
    });
  }

  // Predictive search toggle
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      var input = searchPanel.querySelector('input');
      if (searchPanel.classList.contains('is-open') && input) input.focus();
    });
    document.addEventListener('click', function (e) {
      if (!searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
        searchPanel.classList.remove('is-open');
      }
    });
  }

  // Quantity steppers (product page + cart)
  document.querySelectorAll('[data-quantity-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-quantity-minus]');
    var plus = wrapper.querySelector('[data-quantity-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var val = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var val = (Number.isFinite(parseInt(input.value, 10)) ? parseInt(input.value, 10) : 0) + 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Product variant selector -> sync hidden variant id input
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsJson = form.querySelector('[data-product-variants]');
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-option-select]');
    var hiddenInput = form.querySelector('[data-variant-id]');
    var priceEl = form.closest('.product').querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');

    function currentSelection() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }

    function updateVariant() {
      var selection = currentSelection();
      var match = !selects.length ? variants.find(function(v) { return String(v.id) === hiddenInput.value; }) : variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
      if (match) {
        hiddenInput.value = match.id;
        hiddenInput.disabled = false;
        var sku = form.closest('.product').querySelector('[data-product-sku]');
        var skuRow = form.closest('.product').querySelector('[data-product-sku-row]');
        if (sku) sku.textContent = match.sku || '';
        if (skuRow) skuRow.hidden = !match.sku;
        if (priceEl) {
          priceEl.textContent = match.price_formatted || priceEl.textContent;
          if (match.compare_formatted) {
            var compare = document.createElement('s');
            compare.textContent = match.compare_formatted;
            priceEl.prepend(compare);
          }
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold-out');
        }
      } else if (addBtn) {
        hiddenInput.disabled = true;
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-unavailable') || 'Unavailable';
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
    updateVariant();
  });
});
